import { useEffect, type JSX } from 'react';
import { Wordmark } from '../components/Wordmark.js';
import { useT, type T } from '../i18n/index.js';
import { useApp } from '../state/store.js';
import { applyPrefs, readPrefs } from './lib/prefs.js';
import './Splash.css';

/**
 * S1 — the compound at night, seen from the gate. Boot() moves us on to the
 * age gate or the compound, so this screen has no controls: it is the moment
 * before you walk in.
 */
export function Splash(): JSX.Element {
  const status = useApp((s) => s.status);
  const t = useT();

  // First screen of the session, so it is where saved device preferences —
  // reduced motion, colourblind-safe, language — get put back on the document.
  useEffect(() => applyPrefs(readPrefs()), []);

  return (
    <div className="splash">
      <div className="splash__sky" />
      <div className="splash__moon" />
      <div className="splash__far" />
      <div className="splash__line">
        <span />
        <span />
        <span />
        <span />
      </div>
      <div className="splash__wall" />
      <div className="splash__post" />
      <div className="splash__cone" />
      <div className="splash__pool" />
      <div className="splash__pool splash__pool--cool" />
      <div className="splash__table" />
      <div className="splash__silhouette" />

      <div className="splash__content">
        <div className="splash__mark">
          <Wordmark size={54} lines={2} strapline />
        </div>
        <p className="splash__strap">{t('lobby.splash.strap')}</p>
      </div>

      <div className="splash__status">
        <div className="splash__filament" />
        <span>{bootLine(status, t)}</span>
      </div>
    </div>
  );
}

/** Say which part is slow, so a stall is information and not a spinner. */
function bootLine(status: string, t: T): string {
  switch (status) {
    case 'reconnecting':
      return t('lobby.boot.reconnecting');
    case 'closed':
      return t('lobby.boot.closed');
    default:
      return t('lobby.boot.opening');
  }
}
